import { createCognitoIdentityProvider } from '@mesa-labs/utils/createCognitoIdentityProvider';

const cognitoProvider = createCognitoIdentityProvider(CONFIG.cognito.region, CONFIG.cognito.clientId, CONFIG.cognito.userPoolId);
export default cognitoProvider;